module.exports = {"id":"201215","name":"Ladislav Krejčí","rating":"76","photo":"./data/images/photos/1/201215.png","club":{"name":"Bologne","logo":"./data/images/clubs/Bologne.png"},"positions":["AG","AD","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LadislavKrejci0.json
// module id = 2419
// module chunks = 0